import { useState } from 'react';

const NET_PAR_JOUR = 116.54;
const SEMAINES_PAR_MOIS = 4.33;

export default function SimulateurRevenus() {
  const [joursParSemaine, setJoursParSemaine] = useState(3);

  const netParMois = Math.round(joursParSemaine * SEMAINES_PAR_MOIS * NET_PAR_JOUR);

  const labels = {
    1: '1 jour / semaine',
    2: '2 jours / semaine',
    3: '3 jours / semaine',
    4: '4 jours / semaine',
    5: '5 jours / semaine',
  };

  return (
    <section style={styles.section}>
      <div style={styles.inner}>
        <p style={styles.eyebrow}>Simulateur de revenus</p>
        <h2 style={styles.title}>Combien ça rapporte vraiment&nbsp;?</h2>
        <p style={styles.sub}>Déplacez le curseur selon vos disponibilités</p>

        <div style={styles.resultBlock} data-testid="simulator-result">
          <div style={styles.amount}>
            {netParMois.toLocaleString('fr-FR')}€
          </div>
          <div style={styles.period}>net / mois</div>
        </div>

        <div style={styles.sliderWrap}>
          <div style={styles.sliderLabels}>
            <span style={styles.sliderEdge}>1 jour</span>
            <strong style={styles.sliderCenter}>{labels[joursParSemaine]}</strong>
            <span style={styles.sliderEdge}>5 jours</span>
          </div>
          <div style={styles.rangeBlock}>
            <input
              type="range"
              min={1}
              max={5}
              step={1}
              value={joursParSemaine}
              onChange={(e) => setJoursParSemaine(Number(e.target.value))}
              style={styles.range}
              aria-label="Nombre de jours par semaine"
              data-testid="slider-revenue"
            />
            <div style={styles.ticksRow} aria-hidden>
              {[1, 2, 3, 4, 5].map((n) => (
                <span key={n} style={styles.tick} />
              ))}
            </div>
          </div>
        </div>

        <div style={styles.noteBox}>
          <p style={styles.noteFormula}>
            Calcul basé sur&nbsp;: {joursParSemaine} jour{joursParSemaine > 1 ? 's' : ''} × 9h de travail/jour (à 13,72€ brut/h) × 4,33 semaines. Estimation indicative.
          </p>
          <p style={styles.noteLegal}>
            <strong style={styles.noteStrong}>Taux horaire minimal appliqué.</strong>{' '}
            Un cabinet proposant un taux supérieur augmentera proportionnellement votre rémunération.
          </p>
        </div>
      </div>
    </section>
  );
}

const styles = {
  section: {
    backgroundColor: '#1A3B48',
    padding: '64px 48px',
    textAlign: 'center',
  },
  inner: {
    maxWidth: 600,
    margin: '0 auto',
  },
  eyebrow: {
    fontSize: 11,
    fontWeight: 500,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: '#05BF87',
    marginBottom: 12,
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
    color: '#ffffff',
    marginBottom: 8,
    letterSpacing: '-0.02em',
  },
  sub: {
    fontSize: 14,
    color: 'rgba(255,255,255,0.5)',
    marginBottom: 40,
  },
  resultBlock: {
    marginBottom: 36,
  },
  amount: {
    fontSize: 72,
    fontWeight: 800,
    color: '#05BF87',
    lineHeight: 1,
    letterSpacing: '-0.04em',
    transition: 'all 0.15s ease',
  },
  period: {
    fontSize: 16,
    color: 'rgba(255,255,255,0.5)',
    marginTop: 4,
  },
  sliderWrap: {
    marginBottom: 28,
  },
  rangeBlock: {
    width: '100%',
  },
  ticksRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    width: '100%',
    marginTop: 6,
    paddingLeft: 9,
    paddingRight: 9,
    boxSizing: 'border-box',
  },
  tick: {
    width: 1,
    height: 12,
    backgroundColor: 'rgba(255,255,255,0.4)',
    borderRadius: 1,
    flexShrink: 0,
  },
  sliderLabels: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  sliderEdge: {
    fontSize: 13,
    color: 'rgba(255,255,255,0.5)',
  },
  sliderCenter: {
    fontSize: 15,
    fontWeight: 500,
    color: '#ffffff',
  },
  range: {
    width: '100%',
    accentColor: '#05BF87',
  },
  noteBox: {
    borderTop: '1px solid rgba(255,255,255,0.1)',
    paddingTop: 20,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  noteFormula: {
    fontSize: 12,
    color: 'rgba(255,255,255,0.45)',
    lineHeight: 1.7,
  },
  noteLegal: {
    fontSize: 12,
    color: 'rgba(255,255,255,0.45)',
    lineHeight: 1.7,
  },
  noteStrong: {
    color: 'rgba(255,255,255,0.8)',
    fontWeight: 500,
  },
};
